import { Box, Paper, Tab, Tabs, Typography } from '@mui/material';
import { useState } from 'react';
import CompareTab from './CompareTab';
import { CELL_PRODUCT_FIELDS, CELL_TYPE_FIELDS } from './constants';

const Comparator = () => {
  const [tab, setTab] = useState(0);

  return (
    <Box sx={{ bgcolor: '#F5F7FA', minHeight: 'calc(100vh - 64px)', p: { xs: 2, md: 4 } }}>
      <Box sx={{ maxWidth: 1400, mx: 'auto' }}>
        <Typography variant="h4" sx={{ fontWeight: 700, color: '#002A5C', mb: 0.5 }}>
          Comparator
        </Typography>
        <Typography variant="body2" sx={{ color: '#5C6B7A', mb: 3 }}>
          Compare entities side-by-side on key performance metrics.
        </Typography>

        <Paper
          elevation={0}
          sx={{
            borderRadius: 3,
            border: '1px solid #DEE3EA',
            overflow: 'hidden',
          }}
        >
          <Box sx={{ borderBottom: '1px solid #DEE3EA', px: 3, bgcolor: 'white' }}>
            <Tabs value={tab} onChange={(_, v) => setTab(v)}>
              <Tab label="Cell Type" />
              <Tab label="Cell Product" />
            </Tabs>
          </Box>

          <Box sx={{ p: 3, bgcolor: 'white' }}>
            {tab === 0 && (
              <CompareTab entityKey="cell-types" comparableFields={CELL_TYPE_FIELDS} />
            )}
            {tab === 1 && (
              <CompareTab entityKey="cell-products" comparableFields={CELL_PRODUCT_FIELDS} />
            )}
          </Box>
        </Paper>
      </Box>
    </Box>
  );
};

export default Comparator;
